export type Accent =
  | 'brand'
  | 'gray'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'green'
  | 'teal'
  | 'blue'
  | 'cyan'
  | 'purple'
  | 'pink';

export const ACCENTS: readonly Accent[] = [
  'brand',
  'blue',
  'green',
  'cyan',
  'purple',
  'pink',
  'orange',
  'red',
  'teal',
  'yellow',
  'gray',
];
